import { z } from "zod";
import { PaginationQuerySchema } from "./common.js";
import { CrmDealSchema } from "./crm-deals.js";
export const CrmLeadBandValues = ["hot", "warm", "cold"];
export const CrmLeadBandSchema = z.enum(CrmLeadBandValues);
export const CrmLeadQueueItemSchema = z.object({
    contactId: z.string().uuid(),
    contactName: z.string().min(1).max(220),
    email: z.string().email(),
    companyId: z.string().uuid().nullable(),
    companyName: z.string().nullable(),
    ownerEmail: z.string().email().nullable(),
    source: z.string().max(80).nullable(),
    lifecycleStage: z.string().min(1).max(40),
    marketingConsent: z.string().min(1).max(40),
    fitScore: z.number().int().min(0).max(100),
    engagementScore: z.number().int().min(0).max(100),
    totalScore: z.number().int().min(0).max(100),
    band: CrmLeadBandSchema,
    scoreReasons: z.array(z.string().min(1).max(160)).default([]),
    riskReasons: z.array(z.string().min(1).max(160)).default([]),
    nextAction: z.string().min(1).max(160),
    lastActivityAt: z.string().datetime().nullable(),
    activityCount: z.number().int().nonnegative(),
    openDealCount: z.number().int().nonnegative(),
    latestDealId: z.string().uuid().nullable(),
    latestDealName: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CrmLeadQueueQuerySchema = PaginationQuerySchema.extend({
    band: CrmLeadBandSchema.optional(),
    ownerEmail: z.string().email().optional(),
    source: z.string().max(80).optional(),
});
export const CrmLeadQueueResponseSchema = z.object({
    generatedAt: z.string().datetime(),
    leads: z.array(CrmLeadQueueItemSchema),
    total: z.number().int().nonnegative(),
    hotCount: z.number().int().nonnegative(),
    warmCount: z.number().int().nonnegative(),
    coldCount: z.number().int().nonnegative(),
});
export const CrmLeadParamSchema = z.object({
    contactId: z.string().uuid(),
});
export const CrmLeadQualifySchema = z.object({
    dealName: z.string().min(1).max(200).optional(),
    amountMinor: z.number().int().nonnegative().default(0),
    expectedCloseDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable()
        .optional(),
    nextStep: z.string().max(5000).nullable().optional(),
    nextActionAt: z.string().datetime().nullable().optional(),
});
export const CrmLeadQualificationResponseSchema = z.object({
    deal: CrmDealSchema,
    lead: CrmLeadQueueItemSchema,
    created: z.boolean(),
});
export const CrmLeadDisqualifySchema = z.object({
    reason: z.string().min(3).max(240),
    suppressMarketing: z.boolean().default(false),
});
export const CrmLeadDisqualificationResponseSchema = z.object({
    contactId: z.string().uuid(),
    disqualifiedAt: z.string().datetime(),
    reason: z.string().min(3).max(240),
    suppressedMarketing: z.boolean(),
});
//# sourceMappingURL=crm-leads.js.map